import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=3e6bb0bb&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=3e6bb0bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6bb0bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e6bb0bb')) {
      api.createRecord('3e6bb0bb', component.options)
    } else {
      api.reload('3e6bb0bb', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=3e6bb0bb&scoped=true&", function () {
      api.rerender('3e6bb0bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dXnwG13M0xhJ/JS/comp/DocBox.vue"
export default component.exports